import {
    forwardRef,
    useEffect
} from "react";
import type IRowCardProps from "./type";
import type {
    IRowCardRef
} from "./type";
import {
    useItemPropsFromRowCard
} from "./util";
import type {
    RefForwardingComponent
} from "../../types";
import {
    warnOnce
} from "../../utils/development";
import Item from "../item";

const RowCard: RefForwardingComponent<IRowCardRef, IRowCardProps> = (props, ref) => {
    const {
        itemProps,
        children
    } = useItemPropsFromRowCard(props);

    useEffect(() => {
        warnOnce({
            message: "RowCard is deprecated and will be removed in the next major version. Use Item instead."
        });
    }, []);

    return <Item
        {...itemProps}
        ref={ref}
    >
        {children}
    </Item>;
};
export default forwardRef(RowCard);
